import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SideNavService {

    private state$ = new BehaviorSubject(false);
    private flag: boolean;

    constructor() {
    }

    get status() {
        return this.state$;
    }

    setStatus(status: boolean) {
        this.flag = status;
        this.state$.next(this.flag);
    }

    toggle() {
        this.flag = !this.flag;
        this.state$.next(this.flag);
    }
}
